<template lang="pug" src='./treatments.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { moveTo } from '@/mixins'

export default {
  data () {
    return {
      swiperOption: {
        speed: 750,
        pagination: {
          el: '.treatments__pagination',
          bulletClass: 'treatments__bullet',
          bulletActiveClass: 'treatments__bullet--active',
          clickable: true
        }
      }
    }
  },
  computed: {
    props () {
      return this.$store.state.pages['treatments']
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mixins: [ moveTo ],
  components: {
    Icon
  },
  methods: {
    slidePrev () {
      this.swiper.slidePrev()
    },
    slideNext () {
      this.swiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// treatments.vue?6e88a5d8